import { Injector, Input, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { QueryList } from '@angular/core';
import { ViewChildren } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../base.component';


//This component gets other components's template and enhanced them with a <a> element as a layer support for ContentSquare engine analtzed
//User story 87435

@Component({
  selector: 'analyzed-element',
  templateUrl: './analyzed-element.component.html',
  styleUrls: ['./analyzed-element.component.scss']
})
export class AnalyzedElementComponent extends BaseComponent implements OnInit {
  isAnalyzed : boolean = false;
  globalAttr : any
  
  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit() {

    this.globalAttr = this.storeService.getGlobalAttributes();
    if (this.globalAttr && this.globalAttr["contentsquareYourRates"]) {
      this.isAnalyzed = true;
    }
  }

}
